module.exports = __webpack_public_path__ + "static/img/govcard_white_04.780a431f.svg";